import { render } from "./ProcessingV2.vue?vue&type=template&id=28e6beed&scoped=true"
import script from "./ProcessingV2.vue?vue&type=script&lang=js"
export * from "./ProcessingV2.vue?vue&type=script&lang=js"

import "./ProcessingV2.vue?vue&type=style&index=0&id=28e6beed&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28e6beed"]])

export default __exports__